export default "__VITE_ASSET__Ci40X2lA__"